/* prettier-ignore */

const data = {
  common: {
    title: "Piggy Valut",
    description: "Piggy Valut 관리 시스템",
    buttons: {
      search: "검색",
      login: "로그인",
      register: "가입하기",
      approve: "승인",
      reject: "거절",
      refresh: "새로고침",
      viewDetails: "상세보기",
      back: "뒤로가기",
      save: "저장",
      saving: "저장중...",
      cancel: "취소",
      confirm: "확인",
      delete: "삭제",
      deleting: "삭제중...",
      hide: "숨김",
      show: "보임",
      close: "닫기",
    },
    placeholders: {
      search: "검색...",
    },
    messages: {
      success: "성공",
      updateSuccess: "사용자 정보를 수정했습니다",
      loginSuccess: "로그인 성공",
      logoutSuccess: "로그아웃 성공",
      registerSuccess: "회원가입이 완료되었습니다",
      criticalError: "치명적인 오류가 발생했습니다",
      forbidden: "금지된 요청입니다",
      notAuthorized: "권한이 없습니다",
      noData: "데이터가 없습니다",
      hideFor24Hours: "24시간 동안 보지 않기",
      tooManyRequests: "잠시 후 다시 시도해주세요. 같은 요청을 너무 빠르게 보내고 있습니다.",
      blocked: "차단된 사용자입니다",
      pending: "승인대기 상태입니다",
      ipBlocked: "IP가 차단되었습니다",
      ipBlockedFailed: "IP 차단에 실패했습니다",
      invalidIpAddress: "IP 주소가 유효하지 않습니다",
      serverError: "서버 오류가 발생했습니다",
      invalidInput: "잘못된 입력입니다",
      invalidCredentials: "사용자 이름 또는 비밀번호가 올바르지 않습니다",
      invalidReferrer: "존재하지 않는 추천인입니다",
      referrerRequired: "추천인은 필수입니다",
      notAllowedPartner: "허가되지 않은 파트너입니다",
      invalidPassword: "비밀번호 검증에 실패했습니다",
      databaseError: "데이터베이스 오류가 발생했습니다",
      usernameInUse: "사용자 이름이 이미 사용중입니다",
      createUserError: "사용자 생성에 실패했습니다",
      failedFetch: "데이터를 불러오는데 실패했습니다.",
      failedFetchUser: "사용자 조회에 실패했습니다",
      failedFetchPendingUsers: "승인대기 사용자 조회에 실패했습니다",
      failedFetchOnlineUsers: "온라인 사용자 조회에 실패했습니다",
      failedFetchUserTree: "사용자 조직도 조회에 실패했습니다",
      failedFetchUsers: "사용자 조회에 실패했습니다",
      failedFetchUserUpline: "사용자 상위 조회에 실패했습니다",
      failedFetchUserDownline: "사용자 하위 조회에 실패했습니다",
      failedUpdate: "데이터를 수정하는데 실패했습니다.",
      failedUpdateUser: "사용자 업데이트에 실패했습니다",
      failedSave: "데이터를 저장하는데 실패했습니다.",
      vendorError: "벤더 오류가 발생했습니다",
      confirmDelete: "정말로 삭제하시겠습니까?",
      deleteSuccess: "사용자가 삭제되었습니다",
      tokenRefreshed: "토큰이 갱신되었습니다",
      tokenRefreshFailed: "토큰 갱신에 실패했습니다",
      invalidChipTransactionReason: "알 이동 이유가 유효하지 않습니다",
      captchaExpired: "보안 문제 답변이 만료되었습니다",
      captchaInvalid: "보안 문제 답변이 유효하지 않습니다",
      insufficientChip: "알이 부족합니다",
      insufficientPoint: "포인트가 부족합니다",
      failedCollectChips: "알 수집에 실패했습니다",
      failedGiveChips: "알 지급에 실패했습니다",
      failedPointsToChips: "포인트를 알로 변환에 실패했습니다",
      notFoundHeadquarter: "본사를 찾을 수 없습니다",
      notFoundUser: "존재하지 않는 사용자입니다",
      failedFetchAdmin: "관리자 조회에 실패했습니다",
      failedFetchHeadquarter: "본사 조회에 실패했습니다",
      adminNotAllowed: "관리자는 접근할 수 없습니다",
      partnerNotAllowed: "파트너는 접근할 수 없습니다",
      userNotAllowed: "사용자는 접근할 수 없습니다",
      failedFetchTotalInquiries: "문의 총 개수 조회에 실패했습니다",
      failedFetchInquiries: "문의 목록 조회에 실패했습니다",
      failedCreateInquiry: "문의 생성에 실패했습니다",
      failedUpdateInquiry: "문의 수정에 실패했습니다",
      failedFetchInquiry: "문의 조회에 실패했습니다",
      failedFetchTotalNotices: "공지사항 총 개수 조회에 실패했습니다",
      failedFetchNotices: "공지사항 목록 조회에 실패했습니다",
      failedCreateNotice: "공지사항 생성에 실패했습니다",
      failedUpdateNotice: "공지사항 수정에 실패했습니다",
      failedIncrementNoticeViewCount: "공지사항 조회수 증가에 실패했습니다",
      failedFetchNotice: "공지사항 조회에 실패했습니다",
      failedFetchBankingHistory: "금융 거래 내역 조회에 실패했습니다",
      failedFetchTotalBankingHistory: "금융 거래 내역 총 개수 조회에 실패했습니다",
      failedFetchDownlineBankingHistory: "하위 라인 금융 거래 내역 조회에 실패했습니다",
      failedFetchDownlineTotalBankingHistory: "하위 라인 금융 거래 내역 총 개수 조회에 실패했습니다",
      failedAddBankingHistory: "금융 거래 내역 추가에 실패했습니다",
      failedUpdateBankingHistoryStatus: "금융 거래 내역 상태 수정에 실패했습니다",
      failedFetchChipTransactionHistory: "칩 거래 내역 조회에 실패했습니다",
      failedFetchTotalChipTransactionHistory: "칩 거래 내역 총 개수 조회에 실패했습니다",
      failedFetchDownlineChipTransactionHistory: "하위 라인 칩 거래 내역 조회에 실패했습니다",
      failedFetchDownlineTotalChipTransactionHistory: "하위 라인 칩 거래 내역 총 개수 조회에 실패했습니다",
      failedAddChipTransactionHistory: "칩 거래 내역 추가에 실패했습니다",
      failedFetchGameBetHistoryByCallbackId: "콜백 ID로 게임 베팅 내역 조회에 실패했습니다",
      failedFetchGameBetHistory: "게임 베팅 내역 조회에 실패했습니다",
      failedFetchTotalGameBetHistory: "게임 베팅 내역 총 개수 조회에 실패했습니다",
      failedFetchDownlineGameBetHistory: "하위 라인 게임 베팅 내역 조회에 실패했습니다",
      failedFetchDownlineTotalGameBetHistory: "하위 라인 게임 베팅 내역 총 개수 조회에 실패했습니다",
      failedAddGameBetHistory: "게임 베팅 내역 추가에 실패했습니다",
      failedFetchChipChangeHistory: "칩 변경 내역 조회에 실패했습니다",
      failedFetchTotalChipChangeHistory: "칩 변경 내역 총 개수 조회에 실패했습니다",
      failedAddChipChangeHistory: "칩 변경 내역 추가에 실패했습니다",
      failedFetchGameCallbackHistory: "게임 콜백 기록 조회에 실패했습니다",
      failedFetchTotalGameCallbackHistory: "게임 콜백 기록 총 개수 조회에 실패했습니다",
      failedAddGameCallbackHistory: "게임 콜백 기록 추가에 실패했습니다",
      failedUpdateGameCallbackHistory: "게임 콜백 기록 수정에 실패했습니다",
      failedDeleteGameCallbackHistory: "게임 콜백 기록 삭제에 실패했습니다",
      failedFetchGamePlayHistory: "게임 플레이 기록 조회에 실패했습니다",
      failedFetchTotalGamePlayHistory: "게임 플레이 기록 총 개수 조회에 실패했습니다",
      failedAddGamePlayHistory: "게임 플레이 기록 추가에 실패했습니다",
      failedFetchLoginHistory: "로그인 기록 조회에 실패했습니다",
      failedFetchTotalLoginHistory: "로그인 기록 총 개수 조회에 실패했습니다",
      failedAddLoginHistory: "로그인 기록 추가에 실패했습니다",
      failedFetchPointChangeHistory: "포인트 변경 내역 조회에 실패했습니다",
      failedFetchTotalPointChangeHistory: "포인트 변경 내역 총 개수 조회에 실패했습니다",
      failedAddPointChangeHistory: "포인트 변경 내역 추가에 실패했습니다",
      failedFetchSettings: "설정 목록 조회에 실패했습니다",
      failedFetchSettingByKey: "키로 설정 조회에 실패했습니다",
      failedCreateSetting: "설정 생성에 실패했습니다",
      noFieldsToUpdateSetting: "수정할 필드가 없습니다",
      settingNotFound: "설정을 찾을 수 없습니다",
      failedUpdateSetting: "설정 수정에 실패했습니다",
      failedDeleteSetting: "설정 삭제에 실패했습니다",
      failedUpdateMultipleSettings: "여러 설정 수정에 실패했습니다",
      failedFetchUserDownlineTotalFinance: "하위 라인 총 재정 정보 조회에 실패했습니다",
      failedFetchUserDownlineSettlement: "하위 라인 정산 정보 조회에 실패했습니다",
      failedFetchMyTotalAddedChips: "총 추가된 칩 조회에 실패했습니다",
      failedFetchMyTotalSubtractedChips: "총 차감된 칩 조회에 실패했습니다",
      failedFetchMyMoneyChanges: "자금 변동 내역 조회에 실패했습니다",
      failedFetchTodaysNewUsers: "오늘의 신규 유저 수 조회에 실패했습니다",
      failedFetchTodayStats: "오늘의 통계 조회에 실패했습니다",
      failedFetchTotalPendingUsers: "총 승인 대기 유저 수 조회에 실패했습니다",
      failedFetchTotalOnlineUsers: "총 온라인 유저 수 조회에 실패했습니다",
      failedFetchTotalPendingInquiries: "총 처리 대기 문의 수 조회에 실패했습니다",
      failedFetchTotalDepositAndWithdraw: "총 입출금 정보 조회에 실패했습니다",
      failedFetchMonitoringStats: "모니터링 통계 조회에 실패했습니다",
      failedUpdateUserFinance: "사용자 재정 정보 수정에 실패했습니다",
      failedAddUserChip: "사용자 칩 추가에 실패했습니다",
      failedAddUserPoint: "사용자 포인트 추가에 실패했습니다",
      failedSubtractUserChip: "하위 사용자 칩 감소에 실패했습니다",
      failedCollectSubUserChips: "하위 사용자 칩 수집에 실패했습니다",
      failedGiveChipsToSubUser: "하위 사용자에게 칩 지급에 실패했습니다",
      failedUpdateUserStatus: "사용자 상태 수정에 실패했습니다",
      failedUpdateUserRole: "사용자 역할 수정에 실패했습니다",
      failedUpdateUserOnlineStatus: "사용자 온라인 상태 수정에 실패했습니다",
      failedUpdateGameVendorForDownline: "하위 라인 게임 벤더 수정에 실패했습니다",
      failedCreateUsers: "여러 사용자 생성에 실패했습니다",
      failedFetchUserById: "ID로 사용자 조회에 실패했습니다",
      failedFetchUserByVendorId: "벤더 ID로 사용자 조회에 실패했습니다",
      failedFetchUserFinance: "사용자 재정 정보 조회에 실패했습니다",
      failedFetchUserRowsByRole: "역할별 사용자 수 조회에 실패했습니다",
      failedFetchAdminId: "관리자 ID 조회에 실패했습니다",
      failedFetchHeadquarterId: "본사 ID 조회에 실패했습니다",
      failedFetchUsersByReferrer: "추천인별 사용자 조회에 실패했습니다",
      failedFetchUsersWithoutReferrer: "추천인 없는 사용자 조회에 실패했습니다",
      failedFetchPendingUsersTotal: "총 승인 대기 유저 수 조회에 실패했습니다",
      failedFetchOnlineUsersTotal: "총 온라인 유저 수 조회에 실패했습니다",
      failedFetchUserDetail: "사용자 상세 정보 조회에 실패했습니다",
      userNotFound: "사용자를 찾을 수 없습니다",
      failedFetchVendorHistory: "벤더 이력 조회에 실패했습니다",
      failedAddVendorHistory: "벤더 이력 추가에 실패했습니다",
      failedUpdateVendorHistory: "벤더 이력 수정에 실패했습니다",
      referrerNotFound: "추천인을 찾을 수 없습니다",
      failedToGetAdminId: "관리자 ID 조회에 실패했습니다",
      failedToGetHeadquarterId: "본사 ID 조회에 실패했습니다",
      failedToGetUserDetail: "사용자 상세 정보 조회에 실패했습니다",
      failedToGetUserFinance: "사용자 재정 정보 조회에 실패했습니다",
      failedFetchUserByRole: "역할별 사용자 조회에 실패했습니다",
      failedAddBetAmount: "배팅 금액 추가에 실패했습니다",
      invalidReason: "이유가 유효하지 않습니다",
      refreshTokenRequired: "리프레시 토큰이 필요합니다",
    },
    pagination: {
      previous: "이전",
      next: "다음",
      page: "페이지",
    },
    roles: {
      admin: "관리자",
      headquarter: "본사",
      headquarter_branch: "부본사",
      branch: "지사",
      distributor: "총판",
      store: "매장",
      user: "유저",
    },
    appBar: {
      search: {
        placeholder: "검색...",
      },
      userProfile: "프로필",
      userSettings: "설정",
      darkMode: "다크 모드",
      lightMode: "라이트 모드",
      logout: "로그아웃",
    },
    loading: {
      loading: "로딩중...",
      error: "오류가 발생했습니다: ",
    },
    search: {
      placeholder: "검색어를 입력하세요",
      button: "검색",
      datePlaceholder: "날짜 선택",
    },
    userTree: {
      title: "조직도",
    },
    status: {
      approved: "승인",
      rejected: "거절",
      pending: "승인대기",
      canceled: "취소",
    },
    gameVendorSelect: {
      officialLabel: "공식 게임 벤더",
      unofficialLabel: "비공식 게임 벤더",
      officialPlaceholder: "공식 게임 벤더 선택",
      unofficialPlaceholder: "비공식 게임 벤더 선택",
      save: "저장",
      none: "없음",
    },
    dateRangeSelector: {
      startDatePlaceholder: "시작일",
      endDatePlaceholder: "종료일",
      selectPlaceholder: "기간 선택",
      periods: {
        day: "오늘",
        week: "1주일",
        twoWeeks: "2주일",
        month: "1개월",
        threeMonths: "3개월",
        sixMonths: "6개월",
        year: "1년",
        custom: "직접 설정",
      },
    },
  },
  auth: {
    login: "로그인",
    register: "회원가입",
    loginDescription: "사용자 이름과 비밀번호를 입력하여 로그인하세요.",
    registerDescription: "새로운 계정을 만드세요",
    email: "이메일",
    password: "비밀번호",
    username: "사용자 이름",
    referrer: "추천인",
    referrerPlaceholder: "추천인의 사용자 이름을 입력하세요",
    confirmPassword: "비밀번호 확인",
    loginButton: "로그인",
    registerButton: "가입하기",
    captcha: "보안 문제",
    captchaPlaceholder: "답을 입력하세요",
    loginProcessing: "로그인 중...",
    registerProcessing: "처리중...",
    hasAccount: "이미 계정이 있으신가요?",
    noAccount: "계정이 없으신가요?",
    goToLogin: "로그인하기",
    goToRegister: "회원가입하기",
    minLengthUsername: "사용자 이름은 최소 3자 이상이어야 합니다",
    minLengthPassword: "비밀번호는 최소 8자 이상이어야 합니다",
    invalidCaptcha: "잘못된 보안 문자입니다",
    passwordMismatch: "비밀번호가 일치하지 않습니다",
    loginSuccess: "로그인 성공",
    registerSuccess: "회원가입이 완료되었습니다",
    refresh: "새로고침",
  },
  sidebar: {
    systemManagement: "시스템/공지사항",
    partnerManagement: "파트너 관리",
    userManagement: "사용자 관리",
    bankingManagement: "충환전 관리",
    bettingStatus: "베팅 현황 및 정산",
    apiDocs: "API 문서",
    settings: "설정",
  },
  statsOverview: {
    balance: "보유알",
    pendingApproval: "승인 대기",
    depositRequest: "입금 요청",
    withdrawRequest: "출금 요청",
    inquiry: "1:1 문의",
    currentUsers: "현재 사용자",
    cases: "건",
    users: "명",
    userBalance: "유저 보유알",
    userPoint: "유저 포인트",
    partnerBalance: "파트너 보유알",
    partnerPoint: "파트너 포인트",
  },
  dashboard: {
    title: "대시보드",
    desc: "관리자 대시보드",
    registeredUsers: "등록된 유저",
    activeUsers: "활성 유저",
    systemStatus: "시스템 상태",
    systemNormal: "정상",
    allSystemsOperational: "모든 시스템 정상 작동 중",
    topStats: {
      chip: {
        title: "보유알",
        vendorBalance: "벤더사 보유알",
      },
      point: {
        title: "보유포인트",
        convertButton: "보유알로 전환",
      },
      user: {
        title: "유저",
        listButton: "소속 유저 목록",
      },
    },
    moneyStatus: {
      userBalance: "유저 보유알",
      userPoint: "유저 보유포인트",
      partnerBalance: "파트너 보유알",
      partnerPoint: "파트너 보유포인트",
    },
    transactionSummary: {
      deposit: "충전",
      withdraw: "환전",
      chipGive: "알지급",
      chipCollect: "알회수",
      newUsers: "금일 신규유저",
      profit: "금일 베팅손익",
      profitDesc: "(베팅 - 당첨 - 총롤링)",
    },
    transactionDetails: {
      title: "보유 잔액 = 보유머니 + 롤링, 충환전은 소속 회원에게 충환전된 금액 합계",
      search: "검색",
      prevBalance: "이전보유금",
      deposit: "충전",
      withdraw: "환전",
      currentBalance: "현재보유금",
      bettingWinning: "배팅 / 당첨",
      rolling: "롤링금",
      userBalanceLabel: "유저보유잔액",
      partnerBalanceLabel: "파트너보유잔액",
      depositLabel: "충전",
      chipGiveLabel: "알지급",
      totalLabel: "합계",
      withdrawLabel: "환전",
      chipCollectLabel: "알회수",
      bettingLabel: "배팅금",
      winningLabel: "당첨금",
      bettingResultLabel: "배팅 - 당첨",
      totalRollingLabel: "총 롤링금",
      actualRollingLabel: "실 롤링금",
    },
    transactionHistory: {
      title: "나의 자금 변동내역",
      search: "검색",
      increase: {
        title: "보유금 증가",
        headDeposit: "본사충전",
        upperChipGive: "상부 알지급",
        lowerChipCollect: "하부 알회수",
        rollingConvert: "롤링금전환",
        total: "증가 합계",
      },
      decrease: {
        title: "보유금 감소",
        headWithdraw: "본사 환전",
        upperChipCollect: "상부 알회수",
        lowerChipGive: "하부 알지급",
        total: "감소 합계",
      },
    },
    notice: {
      title: "공지사항",
      columns: {
        id: "#",
        title: "제목",
        createdAt: "작성일시",
      },
    },
  },
  users: {
    list: {
      title: "사용자 목록",
      desc: "등록된 사용자 목록을 관리합니다",
      columns: {
        username: "유저네임",
        details: "상세정보",
        banking: "충환전",
        chip: "보유알",
        point: "포인트",
        affiliation: "소속",
        depositWithdraw: "총입금/총출금",
        slotStats: "(슬롯)/베팅/당첨/롤링",
        casinoStats: "(카지노)/베팅/당첨/롤링",
        sportsStats: "(스포츠)/베팅/당첨/롤링",
      },
      filters: {
        byUsername: "유저네임 순",
        byChip: "보유알 순",
        byLatest: "최신가입 순",
        byOldest: "오래된 순",
      },
    },
    pending: {
      title: "승인대기 목록",
      desc: "승인 대기 중인 사용자 목록을 관리합니다",
      columns: {
        username: "유저네임",
        details: "상세정보",
        status: "상태",
        headquarter: "본사",
        branch: "지사",
        distributor: "총판",
        store: "매장",
        createdAt: "가입일시",
        contact: "연락처",
        actions: "승인",
      },
      approve: "승인",
      reject: "거절",
      pendingStatus: "승인대기",
      viewDetails: "상세보기",
    },
    online: {
      title: "온라인 목록",
      desc: "온라인 중인 사용자 목록을 관리합니다",
      columns: {
        username: "유저네임",
        details: "상세보기",
        accountHolder: "계좌주",
        affiliation: "소속",
        banking: "충환전",
        chip: "보유알",
        depositWithdraw: "총입금/총출금",
        slotStats: "(슬롯)/베팅/당첨/롤링",
        casinoStats: "(카지노)/베팅/당첨/롤링",
        sportsStats: "(스포츠)/베팅/당첨/롤링",
        lastPlayedGame: "최근실행게임",
      },
      noLastGame: "실행 이력 없음",
    },
    chip: {
      giveTitle: "알지급",
      collectTitle: "알회수",
      giftTitle: "알선물",
      giveChip: "알지급",
      collectChip: "알회수",
      giftChip: "알선물",
      description: "금액과 사유를 입력하신 후 확인 버튼을 클릭하세요.",
      amount: "금액",
      memo: "메모",
      memoPlaceholder: "메모를 입력하세요",
      errors: {
        invalidAmount: "유효한 금액을 입력하세요",
        actionFailed: "처리에 실패했습니다",
      },
    },

    status: {
      active: "활성",
      pending: "대기",
      rejected: "거절",
      block: "차단",
      online: "온라인",
      offline: "오프라인",
    },
    detail: {
      title: "유저 상세 정보",
      desc: "유저 상세 정보 페이지입니다.",
      tabs: {
        userInfo: "회원정보",
        loginHistory: "로그인 기록",
        messages: "쪽지",
        chipChangeHistory: "보유알 변동 내역",
        rechargeHistory: "충전받은 내역",
        exchangeHistory: "환전나간 내역",
        chipReceivedHistory: "알지급받은 내역",
        chipSentHistory: "알회수나간 내역",
        gamePlayHistory: "게임실행목록",
        gameBetHistory: "게임베팅내역",
        restrictedGameBetting: "제한게임베팅내역",
        pragmatic: "프라그마틱",
        userLogs: "유저로그이력",
      },
      userSummary: {
        role: "구분",
        username: "유저네임",
        chip: "보유알",
        point: "보유포인트",
      },
      userInfo: {
        title: "유저 상세 정보",
        basicInfo: "기본 정보",
        moneyInfo: "자산 정보",
        gameInfo: "게임 정보",
        bankInfo: "은행 정보",
        number: "번호",
        password: "비밀번호",
        username: "유저네임",
        contact: "연락처",
        status: "상태",
        gameVendor: "게임 벤더",
        gameVendorPlaceholder: "게임 벤더 선택",
        chip: "보유알",
        point: "포인트",
        totalDeposit: "총 입금",
        totalWithdraw: "총 출금",
        slotBet: "슬롯 베팅",
        slotWin: "슬롯 승리",
        casinoBet: "카지노 베팅",
        casinoWin: "카지노 승리",
        sportsBet: "스포츠 베팅",
        sportsWin: "스포츠 승리",
        casinoBetLimit: "라이브 카지노 베팅",
        casinoWinLimit: "라이브 카지노 승리",
        bankName: "은행명",
        bankAccount: "계좌번호",
        bankAccountHolder: "계좌주",
        memo: "메모",
        memoPlaceholder: "메모를 입력하세요",
        createdAt: "가입 일시",
        lastLogin: "최근 로그인",
        blockRejectReason: "차단 및 거절 사유",
        blockRejectReasonPlaceholder: "차단 및 거절 사유를 입력하세요",
      },
      loginHistory: {
        title: "로그인 기록",
        columns: {
          ipAddr: "접속 IP",
          isSuccess: "성공 여부",
          createdAt: "접속 일시",
          actions: "작업",
          blockIP: "IP 차단",
        },
      },
      chipChangeHistory: {
        title: "보유알 변동 내역",
        columns: {
          amountBefore: "변동 전",
          amountAfter: "변동 후",
          amountDiff: "증감",
          sender: "보낸곳",
          receiver: "받은곳",
          reason: "사유",
          referenceValue: "참조 값",
          rollingBefore: "롤링(전)",
          rollingAfter: "롤링(후)",
          createdAt: "변동일시",
        },
      },
      rechargeHistory: {
        title: "충전내역",
        columns: {
          amountBefore: "충전전",
          amountAfter: "충전후",
          requestAmount: "요청 금액",
          bankInfo: "은행 정보",
          status: "상태",
          requestedAt: "요청 일시",
          processedAt: "처리 일시",
          memo: "메모",
        },
      },
      exchangeHistory: {
        title: "환전내역",
        columns: {
          amountBefore: "환전전",
          amountAfter: "환전후",
          requestAmount: "요청 금액",
          bankInfo: "은행 정보",
          status: "상태",
          requestedAt: "요청 일시",
          processedAt: "처리 일시",
          memo: "메모",
        },
      },
      chipReceiveHistory: {
        title: "알 받은 내역",
        columns: {
          receiverId: "받는 사람 ID",
          receiverUsername: "받는 사람 유저네임",
          receiverRole: "받는 사람 구분",
          amount: "알 금액",
          reason: "사유",
          memo: "메모",
          createdAt: "등록일시",
        },
      },
      chipSendHistory: {
        title: "알 보낸 내역",
        columns: {
          senderId: "보낸 사람 ID",
          senderUsername: "보낸 사람 유저네임",
          senderRole: "보낸 사람 구분",
          amount: "알 금액",
          reason: "사유",
          memo: "메모",
          createdAt: "등록일시",
        },
      },
      gamePlayHistory: {
        title: "게임 실행 내역",
        columns: {
          supplier: "게임 제공자",
          gameName: "게임 이름",
          executionTime: "실행 일시",
        },
      },
      gameBetHistory: {
        title: "게임 베팅 내역",
        columns: {
          supplier: "게임 제공자",
          gameName: "게임 이름",
          roundId: "라운드 ID",
          type: "타입",
          betAmount: "베팅 금액",
          winAmount: "당첨 금액",
          balance: "잔액",
          betTime: "베팅 일시",
          details: "상세",
        },
      },
    },
    creation: {
      title: "사용자 생성",
      desc: "새로운 {0}를 생성합니다.",
      username: "사용자 이름",
      usernamePlaceholder: "사용자 이름 입력",
      password: "비밀번호",
      passwordPlaceholder: "비밀번호 입력",
      count: "생성 수",
      countPlaceholder: "생성 수를 입력해주세요",
      contact: "연락처",
      contactPlaceholder: "연락처를 입력하세요",
      bank: "은행",
      bankSelect: "=== 선택 ===",
      bankKookmin: "국민",
      bankShinhan: "신한",
      bankWoori: "우리",
      bankNonghyup: "농협",
      bankHana: "하나",
      accountNumber: "계좌번호",
      accountNumberPlaceholder: "계좌번호를 입력하세요",
      accountHolder: "계좌주",
      accountHolderPlaceholder: "계좌주를 입력하세요",
      rollingRateSlot: "롤링수수료율(슬롯)",
      losingRateSlot: "루징수수료율(슬롯)",
      rollingRateCasino: "롤링수수료율(카지노)",
      losingRateCasino: "루징수수료율(카지노)",
      rollingRateSports: "롤링수수료율(스포츠)",
      losingRateSports: "루징수수료율(스포츠)",
      errors: {
        requiredFields: "사용자 이름과 비밀번호를 입력해주세요",
        invalidCount: "생성 수는 0 이상이어야 합니다",
      },
    },
  },
  partners: {
    common: {
      add: "파트너 추가",
    },
    list: {
      all: {
        title: "전체 파트너 목록",
        desc: "등록된 전체 파트너를 관리합니다",
      },
      head: {
        title: "본사 목록",
        desc: "등록된 본사를 관리합니다",
      },
      headBranch: {
        title: "부본사 목록",
        desc: "등록된 부본사를 관리합니다",
      },
      branch: {
        title: "지사 목록",
        desc: "등록된 지사를 관리합니다",
      },
      distributor: {
        title: "총판 목록",
        desc: "등록된 총판을 관리합니다",
      },
      store: {
        title: "매장 목록",
        desc: "등록된 매장을 관리합니다",
      },
      search: {
        placeholder: "파트너 유저네임을 입력하세요",
      },
      columns: {
        username: "유저네임",
        details: "상세정보",
        role: "구분",
        banking: "충환전",
        chip: "보유알",
        point: "보유포인트",
        depositWithdraw: "입출금",
        rollingPercentage: {
          slot: "롤링 % (슬)",
          casino: "롤링 % (카)",
          sports: "롤링 % (스)",
        },
        losingPercentage: {
          slot: "루징 % (슬)",
          casino: "루징 % (카)",
          sports: "루징 % (스)",
        },
        createdAt: "등록일시",
        hqTransactions: "본사충전 / 본사환전",
        chipTransactions: "알지급 / 알회수",
        betting: {
          casino: "베팅(카)",
          slot: "베팅(슬)",
          sports: "베팅(스)",
        },
        downlineManagement: "하부관리",
        createDownline: "하부등록",
      },
      statsCard: {
        basicInfo: {
          title: "기본정보",
          type: "구분",
          username: "유저네임",
          chipAndPointBalance: "보유알 / 포인트",
          contact: "연락처",
          bankName: "은행명",
          bankAccount: "계좌번호",
          accountHolder: "계좌주",
        },
        rollingAndLosing: {
          title: "롤링 & 루징",
          convertButton: "보유머니로 전환",
          rollingPercentage: {
            slot: "롤링 % (슬롯)",
            casino: "롤링 % (카지노)",
            sports: "롤링 % (스포츠)",
          },
          losingPercentage: {
            slot: "루징 % (슬롯)",
            casino: "루징 % (카지노)",
            sports: "루징 % (스포츠)",
          },
        },
        bettingAndRolling: {
          title: "베팅 및 롤링포인트",
          bettingWinning: {
            title: "베팅/당첨금",
            slot: "베팅/당첨금 (슬롯)",
            casino: "베팅/당첨금 (카지노)",
            sports: "베팅/당첨금 (스포츠)",
          },
          rolling: {
            slot: "롤링포인트 (슬롯)",
            casino: "롤링포인트 (카지노)",
            sports: "롤링포인트 (스포츠)",
          },
        },
        moneyMovement: {
          title: "자금이동",
          totalDeposit: "충전금 합계",
          totalWithdraw: "환전금 합계",
          totalChipGive: "알지급금 합계",
          totalChipCollect: "알회수금 합계",
        },
      },
    },
    chipTransfer: {
      title: "파트너 알이동",
      desc: "파트너 간 알이동을 관리합니다",
      columns: {
        fromUser: "보낸 사람",
        fromRole: "보낸 사람 구분",
        toUser: "받는 사람",
        toRole: "받는 사람 구분",
        amount: "개수",
        memo: "메모",
        createdAt: "이동 시간",
      },
    },
    partnerUserChipTransfer: {
      title: "파트너 ↔ 회원간 알 이동",
      desc: "파트너와 회원 간의 알 이동을 관리합니다",
      search: {
        placeholder: "파트너 또는 회원 이름을 입력하세요",
      },
      columns: {
        partnerUsername: "파트너네임",
        partnerRole: "파트너 구분",
        username: "유저네임",
        giveAmount: "알지급 금액",
        collectAmount: "알회수 금액",
        createdAt: "일시",
      },
    },
  },
  banking: {
    rechargeHistory: {
      title: "충전 내역",
      desc: "충전 내역 페이지입니다.",
      columns: {
        id: "#",
        type: "구분",
        amount: "충전 금액",
        countAndTotal: "충전 건수 / 충전 합계",
        balanceChange: "충전 전 / 충전 후",
        username: "유저네임",
        affiliation: "소속",
        bankName: "은행명",
        accountHolder: "계좌주",
        dates: "요청일시 / 처리일시",
        status: "상태",
        details: "상세정보",
        memo: "메모",
        deposit: "충전",
        withdraw: "환전",
      },
    },
    exchangeHistory: {
      title: "환전 내역",
      desc: "환전 내역 페이지입니다.",
      columns: {
        id: "#",
        type: "구분",
        amount: "환전 금액",
        countAndTotal: "환전 건수 / 환전 합계",
        balanceChange: "환전 전 / 환전 후",
        username: "유저네임",
        affiliation: "소속",
        bankName: "은행명",
        accountHolder: "계좌주",
        dates: "요청일시 / 처리일시",
        status: "상태",
        details: "상세정보",
        memo: "메모",
        deposit: "충전",
        withdraw: "환전",
      },
    },
  },
  notices: {
    list: {
      title: "공지사항 관리",
      desc: "공지사항 관리 페이지입니다.",
      createButton: "공지사항 작성",
      columns: {
        title: "제목",
        status: "상태",
        viewCount: "조회수",
        createdAt: "작성일",
        updatedAt: "수정일",
        actions: "관리",
        pinButton: "고정",
        unpinButton: "고정 해제",
        viewButton: "보기",
        editButton: "수정",
        deleteButton: "삭제",
      },
    },
    detail: {
      title: "공지사항 상세",
      desc: "공지사항 상세 페이지입니다.",
      notFound: "공지사항을 찾을 수 없습니다.",
    },
    edit: {
      title: "공지사항 수정",
      desc: "공지사항 수정 페이지입니다.",
      titleLabel: "제목",
      contentLabel: "내용",
      statusLabel: "상태",
      pinnedLabel: "상단 고정",
    },
    delete: {
      title: "공지사항 삭제",
      desc: "이 공지사항을 삭제하시겠습니까?",
    },
    status: {
      all: "전체",
      draft: "임시저장",
      published: "게시중",
      deleted: "삭제됨",
    },
  },
  inquiry: {
    types: {
      deposit: "충전 문의",
      withdrawal: "환전 문의",
      account: "충전계좌 요청",
      other: "기타 문의",
    },
  },
  inquiries: {
    list: {
      title: "1:1 문의",
      desc: "1:1 문의 페이지입니다.",
      columns: {
        title: "제목",
        status: "상태",
        creator: "작성자",
        createdAt: "작성일",
        answerer: "답변자",
        answeredAt: "답변일",
      },
      search: {
        placeholder: "제목 또는 내용으로 검색",
      },
      noData: "문의 내역이 없습니다.",
    },
    detail: {
      title: "문의 상세",
      desc: "문의 상세 페이지입니다.",
      notFound: "문의를 찾을 수 없습니다.",
    },
    status: {
      all: "전체",
      pending: "대기중",
      inProgress: "처리중",
      completed: "완료",
      deleted: "삭제됨",
    },
    answer: {
      title: "답변",
      status: "처리 상태",
      content: "답변 내용",
      placeholder: "답변을 입력하세요",
      submit: "답변 등록",
      success: "답변이 등록되었습니다.",
      error: "답변 등록에 실패했습니다.",
      required: "답변 내용을 입력해주세요.",
    },
  },
  bettingStatus: {
    common: {
      rollingDesc: "※ 롤링 정산금 = 베팅 x 롤링%, ※ 실지급금 = 정산금 - 하부정산금",
      losingDesc: "※ 루징 정산금 = (베팅 - 당첨 - 총롤링포인트) x 루징%, ※ 실지급금 = 정산금 - 하부정산금",
      selectedPartner: "해당 파트너 베팅 & 롤링데이터",
      downlinePartners: "하부 파트너 베팅 & 롤링데이터",
    },
    slot: {
      title: "베팅 현황(슬롯)",
      desc: "슬롯 베팅 현황 페이지입니다.",
    },
    casino: {
      title: "베팅 현황(카지노)",
      desc: "카지노 베팅 현황 페이지입니다.",
    },
    sports: {
      title: "베팅 현황(스포츠)",
      desc: "스포츠 베팅 현황 페이지입니다.",
    },
    slotHistory: {
      title: "베팅 내역(슬롯)",
      desc: "슬롯 베팅 내역 페이지입니다.",
    },
    casinoHistory: {
      title: "베팅 내역(카지노)",
      desc: "카지노 베팅 내역 페이지입니다.",
    },
    sportsHistory: {
      title: "베팅 내역(스포츠)",
      desc: "스포츠 베팅 내역 페이지입니다.",
    },
    losingSettlement: {
      slot: {
        title: "루징 정산(슬롯)",
        desc: "슬롯 루징 정산 페이지입니다.",
      },
      casino: {
        title: "루징 정산(카지노)",
        desc: "카지노 루징 정산 페이지입니다.",
      },
      sports: {
        title: "루징 정산(스포츠)",
        desc: "스포츠 루징 정산 페이지입니다.",
      },
      columns: {
        role: "구분",
        partnerName: "파트너명",
        totalPartnerDeposit: "파트너 총충전",
        totalPartnerWithdraw: "파트너 총환전",
        totalBetting: "총베팅금",
        totalWinning: "총당첨금",
        bettingResult: "총베팅 - 총당첨",
        rollingPercentage: "롤링%",
        totalRolling: "총 롤링포인트",
        actualRolling: "실지급 롤링",
        losingPercentage: "루징%",
        losingAmount: "루징금",
        settlementAmount: "정산금",
        downlineSettlementAmount: "하부정산금",
        actualPaymentAmount: "실지급금",
      },
    },
    lossAdjustment: {
      title: "로스 조정",
      desc: "로스 조정 페이지입니다.",
      columns: {
        headquarter: "소속본사",
        branch: "소속부본사",
        storeUsername: "매장 유저네임",
        yesterdayBetting: "전일 베팅",
        yesterdayWin: "전일 당첨",
        yesterdayRolling: "전일 롤링",
        subtract: "빼기",
        loss: "LOSS",
        add: "더하기",
      },
      buttons: {
        setAll0: "전체 0으로",
        setAll5: "전체 5로",
        setAll10: "전체 10으로",
        setAll15: "전체 15로",
        setAll20: "전체 20으로",
      },
    },
    lossRecovery: {
      title: "로스 복구",
      desc: "로스 복구 페이지입니다.",
      columns: {
        storeName: "매장네임",
        username: "유저네임",
        gameName: "게임명",
        date: "날짜",
        bettingAmount: "베팅금",
        winningAmount: "당첨금",
        rollingAmount: "롤링금",
        storeRecoveryStatus: "매장별 복구여부",
        userRecoveryStatus: "유저별 복구여부",
        status: "상태",
      },
    },
    bettingStatusColumns: {
      role: "구분",
      partnerName: "파트너명",
      totalPartnerDeposit: "파트너 총충전",
      totalPartnerWithdraw: "파트너 총환전",
      totalBetting: "총베팅금",
      totalWinning: "총당첨금",
      bettingResult: "총베팅 - 총당첨",
      rollingPercentage: "롤링%",
      totalRolling: "총 롤링금",
      actualRolling: "실지급 롤링금",
      bettingProfit: "베팅손익",
      currentChip: "보유알",
      currentRolling: "보유롤링금",
    },
  },
  swagger: {
    title: "API 문서",
    description: "Piggy Vault 관리자 API 문서.",
  },
  settings: {
    title: "설정",
    description: "시스템 설정을 관리합니다",
    tabs: {
      general: "일반",
      currency: "통화",
      exchange: "환율",
      game: "게임",
      etc: "기타",
    },
    groups: {
      general: {
        title: "일반 설정",
        description: "일반 시스템 설정을 구성합니다.",
      },
      currency: {
        title: "통화 설정",
        description: "통화 표시 및 기준 설정을 관리합니다.",
      },
      exchange: {
        title: "환율 설정",
        description: "USDT 환율 관련 설정을 관리합니다.",
      },
      game: {
        title: "게임 설정",
        description: "벤더를 포함한 게임 관련 설정을 구성합니다.",
      },
      etc: {
        title: "기타 설정",
        description: "기타 여러가지 설정을 관리합니다.",
      },
    },
    fields: {
      site_name: {
        label: "사이트 이름",
        description: "웹사이트의 이름입니다.",
      },
      maintenance: {
        label: "점검 모드",
        description: "사이트 점검 모드를 활성화 또는 비활성화합니다. (on/off)",
      },
      std_currency: {
        label: "기준 통화",
        description: "계산에 사용되는 기준 통화입니다.",
      },
      dsp_currency: {
        label: "표시 통화",
        description: "사용자에게 표시되는 통화입니다.",
      },
      usdt_exchange_rate: {
        label: "USDT 환율 설정",
        description: "USDT 환율 JSON 데이터 편집기입니다.",
      },
      std_game_vendor_id: {
        label: "기준 게임 벤더",
        description: "기본 게임 벤더 ID입니다.",
      },
      // 다른 필드들에 대한 번역도 여기에 추가할 수 있습니다.
    },
    messages: {
      settingKeyNotFound: "설정 키 '$key'에 대한 인덱스를 찾을 수 없습니다",
      loadingSettings: "설정 로딩 중...",
      errorLoadingSettings: "설정 로딩 오류",
    },
    save_success: "설정이 성공적으로 저장되었습니다!",
  },
  usdtExchangeRateEditor: {
    rawJsonEditorTitle: "Raw JSON 에디터",
    exchangeRateAndWalletSettingsTitle: "환율 및 지갑 설정",
    usdtExchangeRateLabel: "USDT 환율 (ex_rate)",
    myWalletUrlLabel: "내 지갑 URL (my_wallet)",
    quickAmountsSettingsTitle: "빠른 금액 설정:",
    quickAmounts: {
      hide: "(숨기기)",
      show: "(보이기)",
      amountPlaceholder: "금액",
      labelPlaceholder: "라벨 (예: $10)",
      addAmountButton: "빠른 금액 추가",
    },
    addLanguagePrompt: "추가할 언어 코드를 입력하세요 (예: th):",
    languageExistsError: "이미 해당 언어 설정이 존재합니다.",
    addNewLanguageQuickAmountButton: "새 언어 빠른 금액 추가",
    wallets: {
      title: "출금 지갑 목록 (wallets)",
      walletNumberLabel: "지갑",
      namePlaceholder: "지갑 이름 (예: Polygon Tether)",
      addressPlaceholder: "지갑 주소",
      qrPlaceholder: "QR 코드 이미지 경로 (예: /uploads/polygon-img.jpeg)",
      deleteWalletButton: "이 지갑 삭제",
      addWalletButton: "출금 지갑 추가",
    },
    errors: {
      invalidJsonParse: "잘못된 JSON 형식입니다",
      failedStringifyJson: "JSON 문자열 변환에 실패했습니다 (onChange)",
      invalidJsonFormatOrUseUI:
        "유효하지 않은 JSON 형식입니다. 직접 수정하거나 아래 UI를 사용하세요.",
    },
    rawJsonEditor: {
      editJsonDirectlyLabel: "JSON 직접 수정",
      warningMessage:
        "주의: JSON 형식이 잘못되면 설정이 올바르게 저장되지 않을 수 있습니다.",
    },
    loadingEditor: "에디터 로딩 중...",
  },
};

export default data;
